import { IFlowLayout } from '@faire/web-api--source/indigofair/data/IFlowLayout';
import { IStackLayout } from '@faire/web-api--source/indigofair/data/IStackLayout';

export namespace ILayout {
  /**
   * Return an instance of ILayout with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<ILayout>): ILayout =>
    ({
      ...(partial ?? {}),
    }) as ILayout;
}

/**
 * A class to define how to lay out a list of components
 * spec with details: https://www.notion.so/faire/LayoutSection-1042efb5c25a803581fdf9563611cc67
 */
export interface ILayout {
  flow_layout: IFlowLayout | undefined;
  stack_layout: IStackLayout | undefined;
}
